<template>
    <div class="user-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('release.release')}}</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">

                            <v-autocomplete
                                    v-model="form.relationships['products'].data"
                                    :items="products"
                                    v-bind:label="$t('release.product')"
                                    item-text="attributes.title"
                                    item-value="id"
                                    return-object
                            ></v-autocomplete>

                            <v-autocomplete
                                    v-model="form.relationships['releaseFlows'].data"
                                    :items="releaseFlows"
                                    v-bind:label="$t('release.releaseFlow')"
                                    item-text="attributes.title"
                                    item-value="id"
                                    return-object
                            ></v-autocomplete>

                            <v-autocomplete
                                    v-model="form.relationships['maintainer'].data"
                                    :items="maintainer"
                                    v-bind:label="$t('user.department')"
                                    item-text="attributes.title"
                                    item-value="id"
                                    return-object
                            ></v-autocomplete>

                            <v-text-field v-bind:label="$t('release.revision')" v-model="form.attributes.revision"></v-text-field>

                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {

            this.$store.dispatch('departments/loadAll').then(() => {
                const widgets = this.$store.getters['departments/all'];
                widgets.forEach((item) => {
                    this.maintainer.push(item);
                });
            });

            this.$store.dispatch('products/loadAll').then(() => {
                const widgets = this.$store.getters['products/all'];
                widgets.forEach((item) => {
                    item.attributes.title = item.attributes.title + ' (' + item.attributes.number + ')';
                    this.products.push(item);
                });
            });

            this.$store.dispatch('releaseFlows/loadAll').then(() => {
                const widgets = this.$store.getters['releaseFlows/all'];
                widgets.forEach((item) => {
                    this.releaseFlows.push(item);
                });
            });

            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('users/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['users/byId']({id: this.id});
                    this.form.attributes = widget.attributes;
                    this.form.id = widget.id;
                    this.form.type = widget.type;
                    const parent = widget;
                    this.$store.dispatch('departments/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['departments/related']({parent});
                        console.log(this.form);
                        this.form.relationships['departments'].data = [];
                        this.form.relationships['departments'].data = related;
                    });
                });
            } else {

            }


        },
        methods: {
            ...mapActions({
                delete: 'users/delete',
            }),

            saveAction: function () {

                var widget = this.form;

                delete widget.relationships['products'].data.relationships;
                delete widget.relationships['products'].data.attributes;
                delete widget.relationships['products'].data.links;

                delete widget.relationships['releaseFlows'].data.relationships;
                delete widget.relationships['releaseFlows'].data.attributes;
                delete widget.relationships['releaseFlows'].data.links;

                delete widget.relationships['maintainer'].data.relationships;
                delete widget.relationships['maintainer'].data.attributes;
                delete widget.relationships['maintainer'].data.links;

                if (widget.relationships['products'].data.type == undefined)
                    delete widget.relationships['products'];

                if (widget.relationships['releaseFlows'].data.type == undefined)
                    delete widget.relationships['releaseFlows'];

                if (widget.relationships['maintainer'].data.type == undefined)
                    delete widget.relationships['maintainer'];

                this.$store.dispatch('releases/create', widget).then(() => {
                     this.$router.back();
                });

            }

        },
        computed: {
            ...mapGetters({
                loading: "releases/isLoading",
                error: "releases/isError",
            }),
        },
        data: () => ({

            form: {
                attributes: {
                    revision: '',
                },
                relationships: {
                    'products': {data: []},
                    'releaseFlows': {data: []},
                    'maintainer': {data: []},
                },
            },

            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            releaseFlows: [],
            products: [],
            maintainer: [],
        })
    }
</script>
